import * as React from 'react';
import { PlayerIcon } from './Icons';
import * as styles from './VideoPreview.css';

export interface IVideoPreviewProps {
  url: string;
  onClick?(event: React.MouseEvent<HTMLDivElement>): void;
}

export function VideoPreview({ url, onClick }: IVideoPreviewProps) {
  return (
    <div data-testid="VideoPreview" className={styles['container']} onClick={onClick}>
      <PlayerIcon />
      <img className={styles['img']} src={url} alt="" loading="lazy" />
    </div>
  );
}
